import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {FileMeaningsToExtensionsListInterface} from "./Interfaces/FileMeaningsToExtensionsListInterface";

const restApiConfig = new RESTAPIConfig();

export const FileMeaningsToExtensionsListApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        getFileMeaningsToExtensionsList: builder.query<FileMeaningsToExtensionsListInterface, void>({
            query: () => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.fileMeaningsToExtensionsList(),
            }),
            providesTags: ["FetchedData", "FileMeaningsToExtensions"]
        })
    })
});

export const {useGetFileMeaningsToExtensionsListQuery} = FileMeaningsToExtensionsListApiSlice;
